var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 181,
    viewBox: "0 0 145 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8587 62.7858L99.9319 47.5723M58.0011 97.5012L110.074 82.2877M102.859 122.074L120.217 117.003M48.6415 194.432L8.07214 55.5704C6.72718 50.9668 7.26607 46.0175 9.57024 41.8113C11.8744 37.6051 15.7551 34.4865 20.3587 33.1415L107.147 7.78567C111.751 6.44072 116.7 6.9796 120.906 9.28378C125.113 11.588 128.231 15.4687 129.576 20.0722L170.145 158.934L139.038 149.183L126.751 171.612L104.322 159.325L92.0357 181.754L69.6069 169.468L48.6415 194.432Z",
    stroke: "#FF6900",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.009dddb8a8a5e66fc33448fecabe3bc6.svg";
export { ForwardRef as ReactComponent };